import { render, staticRenderFns } from "./clickSignUp.vue?vue&type=template&id=a4f29a56&scoped=true"
import script from "./clickSignUp.vue?vue&type=script&lang=js"
export * from "./clickSignUp.vue?vue&type=script&lang=js"
import style0 from "./clickSignUp.vue?vue&type=style&index=0&id=a4f29a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f29a56",
  null
  
)

export default component.exports